export default [
  'file',
  'type',
  'identifier',
  'title',
  'description',
  'schema',
  'value',
  'tableColumnOrder',
  'tableColumns',
  'rowOrder',
  'yTitle',
  'yMin',
  'yMax',
  'xTitle',
  'xMin',
  'xMax',
  'options',
  'multi',
  'required',
  'hidden',
  'disabled',
  'logic',
  'requiredLogic',
  'metadata',
  'signer',
  'tipTitle',
  'tipDescription',
  'tipVisible',
  'tz',
  'hiddenViews',
  'decorators',
  'rowDecorators',
  'decorate',
  'settings',
  'editability',
  'maxRows'
];
